import React from 'react';
import PropTypes from 'prop-types';
import {AddNotes} from './AddNotes';
import {NotesList} from './NotesList';
import {StepNumber} from './StepNumber';
import {STEP_STATE} from './StepItem.constants';
import {Colours} from '@learningblocks/shared-components';
import {Icons} from '@learningblocks/exp-constants';

const {NotebookSolid: ShowNotes, PencilSolid: AddNotesIcon} = Icons;

export function StepItem(props) {
  const [state, setState] = React.useState({
    showNotes: false,
    addingNote: false,
  });

  const showNotes = () => setState({showNotes: true, addingNote: false});

  const resetState = () => setState({showNotes: false, addingNote: false});

  const setAddingNotes = () => setState({showNotes: false, addingNote: true});

  const getStepState = () => {
    if (props.complete) {
      return STEP_STATE.DISABLED;
    } else if (props.current) {
      return STEP_STATE.ACTIVE;
    } else {
      return STEP_STATE.INACTIVE;
    }
  };

  const shouldExpand = () => state.showNotes || state.addingNote;

  const setClassName = () => {
    const expand = shouldExpand() ? 'expanded' : '';
    return `step ${getStepState()} ${expand}`;
  };

  const hasNotes = !!props.notes.length;

  const renderShowNotesButton = () =>
    hasNotes && (
      <span className='step_top_showNotes' onClick={showNotes}>
        <ShowNotes style={{fill: Colours.colorPrimary}} />
      </span>
    );

  const renderNotesList = () =>
    state.showNotes && <NotesList notes={props.notes} close={resetState} />;

  const onAddNote = (note) => props.addNote({stepId: props.stepId, note});

  const renderAddNotes = () =>
    state.addingNote && <AddNotes addNote={onAddNote} close={resetState} />;

  const renderExpandedSection = () =>
    shouldExpand() && (
      <div className='step_btm'>
        {renderNotesList()}
        {renderAddNotes()}
      </div>
    );

  return (
    <div className={setClassName()} aria-label={props.ariaLabel}>
      <div className='step_top'>
        <StepNumber
          className='step_top_number'
          stepId={props.stepId}
          state={getStepState()}
        />
        <p className='step_top_label'>{props.task}</p>
        {renderShowNotesButton()}
        <span className='step_top_addNote' onClick={setAddingNotes}>
          <AddNotesIcon style={{fill: Colours.colorPrimary}} />
        </span>
      </div>
      {renderExpandedSection()}
    </div>
  );
}

StepItem.propTypes = {
  /**
   * UniqueId of step
   */
  stepId: PropTypes.number,
  /**
   * ariaLabel for the task
   */
  ariaLabel: PropTypes.string,
  /**
   * boolean to set if step complete
   */
  complete: PropTypes.bool,
  /**
   * boolean to set if the step is the active one
   */
  current: PropTypes.bool,
  /**
   * List of notes associated with step
   */
  notes: PropTypes.arrayOf(PropTypes.string),
  /**
   * description of task
   */
  task: PropTypes.string,
  /**
   * Function to add new a note to list
   */
  addNote: PropTypes.func,
};

StepItem.defaultProps = {};
